import {
    requestMethodTypes,
    requestHeaderNames,
    requestHeaderValue,
} from '../Constants/api.constants';

const userActionsWatched = (
    requestData = {},
) => {
    const {
        AUTHORIZATION,
        CONTENT_TYPE,
    } = requestHeaderNames;
    const {
        CONTENT_TYPE_JSON,
        BEARER,
    } = requestHeaderValue;

    const method = requestMethodTypes.POST;
    const headers = {
        [CONTENT_TYPE]: CONTENT_TYPE_JSON,
        [AUTHORIZATION]: `${BEARER} ${requestData.token}`,
    };
    const data = {
        assetId: requestData.assetId,
        duration: requestData.duration,
        type: requestData.type,
    };

    const request = {
        method,
        headers,
        data,
    };

    return request;
};

export {
    userActionsWatched as default,
};
